<section class="container-sm">
  <div class="row">
    <div class="col-12">
      @if (highlightSection.title || highlightSection.anchor) {
        <mb-section-headline
          [headline]="highlightSection.title"
          [anchor]="highlightSection.anchor"
          [containerClass]="''"
        ></mb-section-headline>
      }
    </div>
  </div>
  <article class="row flex-column flex-lg-row" [class.reversed]="highlightSection.inverse">
    <div class="image-wrapper col-12 col-sm-11 col-lg-8 offset-lg-0">
      @if (highlightSection.image) {
        <mb-image [media]="highlightSection.image"></mb-image>
      }
      @if (highlightSection.chapterLinks && highlightSection.chapterLinks.length) {
        <a [attr.aria-label]="highlightSection.headline" [routerLink]="highlightSection.chapterLinks[0].routerLink">
          <span class="copy-s badge d-sm-none">
            {{
              highlightSection.chapterLinks.length
                | i18nPlural: { '=1': 'CHAPTER_COUNT_1', other: 'CHAPTER_COUNT_N' }
                | translate: { count: highlightSection.chapterLinks.length }
            }}
          </span>
        </a>
      }
    </div>

    <div class="col-12 col-sm-8 offset-sm-2 offset-lg-0 col-lg-4 content">
      <div>
        <h3>{{ highlightSection.headline }}</h3>
        <p class="copy-l">{{ highlightSection.teaserText }}</p>
        @if (highlightSection.chapterLinks && highlightSection.chapterLinks.length) {
          <a class="btn btn-plain btn-text" [routerLink]="highlightSection.chapterLinks[0].routerLink">{{
            'READ_MORE' | translate
          }}</a>
        }
      </div>
      @if (highlightSection.chapterLinks && highlightSection.chapterLinks.length > 1) {
        <div class="d-none d-sm-block">
          <p class="copy-l">{{ 'ALL_CHAPTERS' | translate }}:</p>
          <nav>
            @for (chapter of highlightSection.chapterLinks; track chapter.routerLink) {
              <a class="btn btn-plain btn-text" [routerLink]="chapter.routerLink">{{ chapter.label }}</a>
            }
          </nav>
        </div>
      }
    </div>
  </article>
</section>
